import {
    type FC,
    useId
} from "react";
import {
    View
} from "react-native";
import type IPopoverSurfaceGroupProps from "./type";
import stylesheet from "./stylesheet";
import PopoverSurfaceHeading from "../heading";

const PopoverSurfaceGroup: FC<IPopoverSurfaceGroupProps> = ({
    headingStyle,
    customTheme,
    children,
    heading,
    style,
    ...props
}) => {
    const baseId = useId();

    const headingId = `${baseId}-heading`;

    const renderHeading = () => {
        if(!heading) {
            return null;
        }

        return <PopoverSurfaceHeading
            customTheme={customTheme}
            style={headingStyle}
            id={headingId}
        >
            {heading}
        </PopoverSurfaceHeading>;
    };

    return <View
        {...props}
        aria-labelledby={heading ? headingId : undefined}
        style={[
            style,
            stylesheet.group
        ]}
        role="group"
    >
        {renderHeading()}
        {children}
    </View>;
};
export default PopoverSurfaceGroup;
